import EdCom from './EdCom';
export default EdCom;
